import { useContext, useState,useEffect } from "react";
import { useNavigate } from "react-router";
import MyContext from "../../context/Context";
import toast from "react-hot-toast";
import { fireDB } from "../../firebase/FirebaseConfig";
import { getAuth } from "firebase/auth";
import Loader from "../../components/Loader/Loader";
import { Timestamp, addDoc, collection } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const categoryList = [
  { name: "select category" },
  { name: "POT" },

];

const sizeOptions = [
  { label: "CUBEE C01 - Length x Width x Height 6x6x6", value: "C01", price: 495 },
  { label: "CUBEE C02 - Length x Width x Height 9x9x9", value: "C02", price: 849 },
  { label: "CUBEE C03 - Length x Width x Height 11x11x11", value: "C03", price: 1999 },
  { label: "CUBEE C04 - Length x Width x Height 15x15x15", value: "C04", price: 2980 },
  { label: "TUBO T01 -  Length x Width x Height 0x10x12", value: "T01", price: 1385 },
  { label: "TUBO T02 -  Length x Width x Height 0x13x17", value: "T02", price: 2255 },
  { label: "WIDEE W01 - Length x Width x Height 0x11x11", value: "W01", price: 1375 },
  { label: "WIDEE W02 - Length x Width x Height 0x13x13", value: "W02", price: 1485 },
  { label: "WIDEE W03 - Length x Width x Height 0x15x15", value: "W03", price: 2255 },
  { label: "WIDEE W04 - Length x Width x Height 0x17x17", value: "W04", price: 3350 },
  { label: "TRIYA TR01 - Length x Width x Height 11x11x11", value: "TR01", price: 1499 },
  { label: "TRIYA TR02 - Length x Width x Height 0x14x13", value: "TR02", price: 1865 },
  { label: "TRIYA TR03 - Length x Width x Height 0x17x14.5", value: "TR03", price: 3160 },
  { label: "TRIYA TR04 - Length x Width x Height 0x20x16", value: "TR04", price: 4375 },
  { label: "BOXA B01 -   Length x Width x Height 24x8x0", value: "B01", price: 2075 },
  { label: "BOXA B02 - Length x Width x Height 30x12x0", value: "B02", price: 4450 },
  { label: "BOXA B03 - Length x Width x Height 36x12x0", value: "B03", price: 5485 },
  { label: "OVALIN OV01 - Length x Width x Height 24x14x12", value: "OV01", price: 2000 },// WRONG PRICE
  { label: "OVALIN OV02 - Length x Width x Height 18x11x10", value: "OV01", price: 3000 },// WRONG PRICE
  { label: "BONSAI BON01 - Length x Width x Height 0x18x7.6", value: "BON01", price: 2000 },// WRONG PRICE
  { label: "BONSAI BON02 - Length x Width x Height 0x24x10", value: "BON02", price: 3000 },// WRONG PRICE
  { label: "BONSAI BON03 - Length x Width x Height 0x36x170", value: "BON03", price: 4000 },// WRONG PRICE
  

];


const AddProduct = () => {
  const context = useContext(MyContext);
  const { loading, setLoading } = context;
  const navigate = useNavigate();

  const auth = getAuth();
  const user = auth.currentUser;
  const users = JSON.parse(localStorage.getItem("users"));

  const [product, setProduct] = useState({
    title: "",
    price: "",
    // sizeCode: "",
    productImageUrl: [],
    category: "",
    description: "",
    quantity: 1,
    time: Timestamp.now(),
    date: new Date().toLocaleString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    }),
  });
  

  const [imageFiles, setImageFiles] = useState([null]);

  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    const newFiles = [...imageFiles];
    newFiles[index] = file;
    setImageFiles(newFiles);
  };

  const removeImageField = (index) => {
    const newFiles = imageFiles.filter((_, i) => i !== index);
    setImageFiles(newFiles);
  };

  const uploadImagesAndGetUrls = async () => {
    const storage = getStorage();
    const urls = [];

    for (const file of imageFiles) {
      if (file) {
        const storageRef = ref(storage, `productImages/${Date.now()}-${file.name}`);
        const snapshot = await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(snapshot.ref);
        urls.push(downloadURL);
      }
    }

    return urls;
  };

  const addProductFunction = async () => {
    if (!product.title || !product.price || imageFiles.length === 0 || !product.category || !product.description) {
      return toast.error("All fields are required");
    }

    if (!user) {
      return toast.error("User not authenticated");
    }

    setLoading(true);
    try {
      const imageUrls = await uploadImagesAndGetUrls();
      const productRef = collection(fireDB, "products");

      await addDoc(productRef, {
        ...product,
        productImageUrl: imageUrls,
        sizeLabel: sizeOptions.find(item => item.value === product.sizeCode)?.label || "",
        userId: user.uid,
        username: users.name,
        email: users.email,
        approved: true,
      });

      toast.success("Product added successfully!");
      navigate(`/adminDashboard`);
    } catch (error) {
      console.error(error);
      toast.error("Failed to add product");
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    // Scroll to the top when the component loads
    window.scrollTo(0, 0);

}, []);



  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 p-4">
 {loading && (
  <div className="fixed inset-0  bg-opacity-80 z-50 flex items-center justify-center">
    <Loader />
  </div>
)}

     

      <div className="bg-white p-8 border border-gray-200 rounded-lg shadow-lg w-full max-w-lg">
        <h2 className="text-center text-2xl font-bold text-gray-700 mb-5">Add Product</h2>

        <input
          type="text"
          value={product.title}
          onChange={(e) => setProduct({ ...product, title: e.target.value })}
          placeholder="Product Title"
          className="input-field"
        />

        {/* <input
          type="number"
          value={product.price}
          onChange={(e) => setProduct({ ...product, price: e.target.value })}
          placeholder="Product Price"
          className="input-field"
        />  */}

        {/* <input
  type="number"
  value={product.price}
  readOnly
  placeholder="Product Price"
  className="input-field"
/> */}

        {/* <select
  value={product.sizeCode}
  onChange={(e) => {
    const selected = sizeOptions.find((item) => item.value === e.target.value);
    if (selected) {
      setProduct({
        ...product,
        sizeCode: selected.value,
        price: selected.price,
      });
    }
  }}
  className="input-field"
>
  <option disabled value="">
    Select Size
  </option>
  {sizeOptions.map((option) => (
    <option key={option.value} value={option.value}>
      {option.label}
    </option>
  ))}
</select> */}


        {/* Image Upload Fields with Remove Button */}
        {imageFiles.map((file, index) => (
          <div key={index} className="mb-2 flex items-center gap-2">
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleImageChange(e, index)}
              className="input-field"
            />
            {file && <p className="text-sm text-gray-500">{file.name}</p>}

            {/* Remove Button */}
            {imageFiles.length > 1 && (
              <button
                type="button"
                onClick={() => removeImageField(index)}
                className="text-red-500 text-sm underline"
              >
                Remove
              </button>
            )}
          </div>
        ))}

        {/* Add new image input */}
        {imageFiles.length < 5 && (
          <button
            type="button"
            onClick={() => setImageFiles([...imageFiles, null])}
            className="mb-4 text-blue-500 underline"
          >
            + Add Image
          </button>
        )}

        <select
          value={product.category}
          onChange={(e) => setProduct({ ...product, category: e.target.value })}
          className="input-field"
        >
          <option disabled>Select Product Category</option>
          {categoryList.map((value, index) => (
            <option key={index} value={value.name}>
              {value.name}
            </option>
          ))}
        </select>

        <textarea
          value={product.description}
          onChange={(e) => setProduct({ ...product, description: e.target.value })}
          placeholder="Product Description"
          rows="4"
          className="input-field"
        ></textarea>

        <button onClick={addProductFunction} type="button" className="btn-submit">
          Add Product
        </button>
      </div>

      <style>{`
        .input-field {
          width: 100%;
          padding: 10px;
          margin-bottom: 10px;
          border: 1px solid #ddd;
          border-radius: 6px;
          outline: none;
        }
        .btn-submit {
          width: 100%;
          background: #28a745;
          color: white;
          padding: 10px;
          border-radius: 6px;
          font-weight: 600;
          text-align: center;
        }
      `}</style>
    </div>
  );
};

export default AddProduct;
